/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetOfferingExemptionInputJsonApiModel = {
  id: "",
  filters: {
    jsonApi: "hasOne",
    type: "offering-exemption-filters",
  },
};
